var map = {
	"./cn": 195,
	"./cn.json": 195,
	"./cs": 196,
	"./cs.json": 196,
	"./de": 197,
	"./de.json": 197,
	"./dk": 198,
	"./dk.json": 198,
	"./el": 199,
	"./el.json": 199,
	"./en": 200,
	"./en.json": 200,
	"./es": 201,
	"./es.json": 201,
	"./fr": 202,
	"./fr.json": 202,
	"./hi": 203,
	"./hi.json": 203,
	"./hr": 204,
	"./hr.json": 204,
	"./hu": 205,
	"./hu.json": 205,
	"./it": 206,
	"./it.json": 206,
	"./kk": 207,
	"./kk.json": 207,
	"./lv": 208,
	"./lv.json": 208,
	"./nb": 209,
	"./nb.json": 209,
	"./pl": 210,
	"./pl.json": 210,
	"./pt": 211,
	"./pt.json": 211,
	"./ro": 212,
	"./ro.json": 212,
	"./ru": 213,
	"./ru.json": 213,
	"./tr": 214,
	"./tr.json": 214,
	"./tw": 215,
	"./tw.json": 215,
	"./uk": 216,
	"./uk.json": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;